import {
  CLEAR_COMPLETION_MAP,
  GET_SESSIONS_DATA,
  LOADING_SESSIONS_DATA,
  PAGINATION_SESSIONS_DATA,
  SEARCH_SESSIONS_DATA,
  SET_CURRENT_SESSION,
  SET_SESSION_COMPLETION,
} from "store/actions/sessions";
export default function clients(state = null, action) {
  if (state == null) {
    return {
      searchedSessions: [],
      sessions: [],
      currentPage: 1,
      totalItem: 0,
      isLoadingSessions: false,
      currentSession: null,
      completionMap: {},
    };
  }
  switch (action.type) {
    case GET_SESSIONS_DATA:
      return {
        ...state,
        sessions: action.payload,
        searchedSessions: action.payload,
      };
    case PAGINATION_SESSIONS_DATA:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SEARCH_SESSIONS_DATA:
      return {
        ...state,
        currentPage: 1,
        sessions: action.payload,
      };
    case LOADING_SESSIONS_DATA:
      return {
        ...state,
        isLoadingSessions: action.payload,
      };
    case SET_CURRENT_SESSION:
      return {
        ...state,
        currentSession: action.payload,
      };
    case SET_SESSION_COMPLETION: {
      const { weekIndex, dayIndex, isCompleted } = action.payload;
      return {
        ...state,
        completionMap: {
          ...state.completionMap,
          [`${weekIndex}_${dayIndex}`]: isCompleted,
        },
      };
    }
    case CLEAR_COMPLETION_MAP:
      return {
        ...state,
        completionMap: {},
      };
    default:
      return state;
  }
}
